import type { z } from 'zod';

import { getCountryPostalCodeUse } from './country';

type PostalCodeParts = {
  country: string;
  postCode: string;
};

type PostalCodeRefinementConfig<T> = {
  getParts: (data: T) => Partial<PostalCodeParts>;
  message: string;
  path: PropertyKey[];
};

export const createPostalCodeRefinement = <T>({ getParts, message, path }: PostalCodeRefinementConfig<T>) => ({
  refinement: async (data: T) => {
    const { country = '', postCode = '' } = getParts(data);

    return postCode.trim() !== '' || (await getCountryPostalCodeUse(country)) !== 'required';
  },
  params: {
    message,
    path,
    when: (payload: { value: unknown }) => {
      const { country, postCode } = getParts(payload.value as T);

      return typeof country === 'string' && typeof postCode === 'string';
    },
  } satisfies Parameters<z.ZodTypeAny['refine']>[1],
});
